import { staticImplementsDecorator } from '@mkx/decorators/static-implements.decorator';
import { ApiResponseEntityBuilderInterface } from '@mkx/interfaces/common/api-response-entity-builder.interface';
import { Expose, plainToInstance } from 'class-transformer';
import 'reflect-metadata';
import { SelectOptionInterface } from '@mkx/interfaces/common/select-option.interface';
import { IconModel } from '@mkx/models/icon.model';

@staticImplementsDecorator<ApiResponseEntityBuilderInterface>()
export class BankModel implements SelectOptionInterface<BankModel> {
  private selected = false;

  @Expose({ groups: ['read', 'post', 'put'], name: 'id' })
  private id: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'combination_name' })
  private combinationName: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'company_name' })
  private companyName: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'company_address' })
  private companyAddress: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'vat_number' })
  private vatNumber: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'bank_name' })
  private bankName: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'iban' })
  private iban: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'swift_bic' })
  private swiftBic: string;

  static buildFromAPIResponse(body: any): any {
    return plainToInstance(BankModel, body, { groups: ['read'] });
  }

  public getId(): string {
    return this.id;
  }

  public getCombinationName(): string {
    return this.combinationName;
  }

  public getCompanyName(): string {
    return this.companyName;
  }

  public getCompanyAddress(): string {
    return this.companyAddress;
  }

  public getVatNumber(): string {
    return this.vatNumber;
  }

  public getBankName(): string {
    return this.bankName;
  }

  public getIban(): string {
    return this.iban;
  }

  public getSwiftBic(): string {
    return this.swiftBic;
  }

  selectOptionGetColorClass(): string | null {
    return undefined;
  }

  selectOptionGetDescription(): string | null {
    return undefined;
  }

  selectOptionGetIcon(): IconModel | null {
    return undefined;
  }

  selectOptionGetIdentifier(): any {
    return this.id;
  }

  selectOptionGetLabel(): string {
    return this.combinationName;
  }

  selectOptionGetLabelProperty(): string {
    return 'combinationName';
  }

  selectOptionGetValue(): BankModel {
    return this;
  }

  selectOptionIsDisabled(): boolean {
    return false;
  }

  selectOptionLabelIsUrl(): boolean {
    return false;
  }

  selectOptionSelect() {
    this.selected = true;
  }

  selectOptionDeselect() {
    this.selected = false;
  }

  selectOptionIsSelected(): boolean {
    return this.selected;
  }
}
